import { delay, call, put, takeLatest, race } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";

import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import {
  cancelInvoiceDepositAction,
  getConfirmationAction,
  getConfirmationNotificationAction,
  getConfirmationToolTipAction,
  getLeadConfirmationLinkAction,
  setConfirmationAction,
  setConfirmationNotificationAction,
  setConfirmationToolTipAction,
  setLeadConfirmationDownloaded,
  setLoaderMessage,
  setResponseCancelInvoiceDeposit,
  setUpdateConfirmationAction,
  setUpdateConfirmationToolTipAction,
  transferInvoiceDepositAction,
  unassignServiceResponse,
  unassignWorkerServiceAction,
  updateConfirmationAction,
  updateConfirmationToolTipAction,
} from "../reducers/clientConfirmationSlice";
import {
  setAddLeadLogAction,
  setAddNewLeadAction,
  setUpdateLeadAction,
} from "../reducers/leadSlice";
import JsFileDownloader from "js-file-downloader";
import store from "../store";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getConfirmationToolTipSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const leadId = action.payload;
    const apiResponse = yield call<any>(
      callAPI,
      action.payload,
      "get",
      `leads/${leadId}/confirmation-tooltip`,
    );

    if (apiResponse?.success === true) {
      yield put(setConfirmationToolTipAction(apiResponse?.data));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* updateConfirmationToolTipSaga(action: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const leadId = action?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      action?.payload,
      "post",
      `leads/${leadId}/confirmation-tooltip`,
    );

    if (apiResponse?.success) {
      // apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateConfirmationToolTipAction(true));
      yield put(getConfirmationToolTipAction(leadId));
      // apiResponse && handleSuccess(apiResponse);
    }
  } catch (error: any) {
    // error?.response && handleError(error?.response?.data)
    yield put(setUpdateConfirmationToolTipAction(false));
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getConfirmationSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const leadId = action.payload;
    const apiResponse = yield call<any>(
      callAPI,
      action.payload,
      "get",
      `leads/${leadId}/confirmation`,
    );

    if (apiResponse?.success === true) {
      yield put(setConfirmationAction(apiResponse?.data));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* updateConfirmationSaga(action: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const {
      colectionVolume,
      collectionVolumeUnit,
      deliveryVolume,
      deliveryVolumeUnit,
      comments,
      isVehicleAssigned,
      acceptedStatus,
      confirmedOn,
      notes,
      driverQty,
      porterQty,
      packerQty,
      contentsValue,
      isJobCreated,
      // paymentMethod,
      insuranceAmount,
      insurancePercentage,
      insuranceType,
      insuranceTypeId,
      generateId,
      // contentValue,
      movingDate,
      packingDate,
      collectionAddresses,
      deliveryAddresses,
      isDepositAmountExceeds,
      materialPriceChargeable,
      quote_total,
      quote_note,
      isWorkerAssigned,
      ...payload
    } = action.payload;

    const apiResponse = yield call<any>(
      callAPI,
      { payload: payload },
      "post",
      `leads/${generateId}/confirmation`,
    );

    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      console.log("apiResponse", apiResponse);
      yield put(setUpdateConfirmationToolTipAction(true));
      yield put(getConfirmationToolTipAction(generateId));
      yield put(getConfirmationAction(generateId));
      // yield put(setAddLeadLogAction(true));
      yield put(setUpdateLeadAction(true));
      yield put(setUpdateConfirmationAction(true));
      apiResponse && handleSuccess(apiResponse);
    }
  } catch (error: any) {
    // error?.response && handleError(error?.response?.data)
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* runLoaderSteps(type: string) {
  if (!["email", "pdf", "odt"].includes(type)) return;

  yield put(setLoaderMessage("Validating confirmation data..."));
  yield delay(3000);

  yield put(setLoaderMessage("Generating ODT template..."));
  yield delay(2000);

  yield put(setLoaderMessage("Converting to PDF..."));
  yield delay(8000);

  yield put(setLoaderMessage("Uploading to secure storage..."));
  yield delay(2000);
}

function* getLeadConfirmationLinkSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));

  try {
    const {
      colectionVolume,
      collectionVolumeUnit,
      deliveryVolume,
      deliveryVolumeUnit,
      comments,
      confirmedOn,
      notes,
      isVehicleAssigned,
      driverQty,
      porterQty,
      packerQty,
      contentsValue,
      isJobCreated,
      paymentMethod,
      insuranceAmount,
      invoiceNumber,
      invoiceType,
      insuranceTypeId,
      insurancePercentage,
      insuranceType,
      leadId,
      type,
      screenType,
      collectionAddresses,
      deliveryAddresses,
      movingDate,
      packingDate,
      isDepositAmountExceeds,
      generalInfo,
      ancillaries,
      materials,
      subcontractorCharges,
      createdAt,
      quoteId,
      contentValue,
      costTotal,
      quote_total,
      quoteTotal,
      accepted_status,
      acceptedStatus,
      quoteExpiresOn,
      materialPriceChargeable,
      isWorkerAssigned,
      quote_note,
      ...newPayload
    } = payload?.payload;
    let url: any = "";

    url = `leads/${leadId}/confirmation?action=${type}`;

    // 👉 API runs + loader steps together
    const { apiResponse } = yield race({
      apiResponse: call(callAPI, { payload: newPayload }, "post", url),
      loaderSteps: call(runLoaderSteps, type),
    });

    // 🛑 STOP LOADER STEPS IMMEDIATELY WHEN API FINISHES
    yield put(setLoaderMessage(""));

    if (apiResponse?.success === true) {
      if (type === "email") {
        apiResponse && handleSuccess(apiResponse);
        store.dispatch(setLeadConfirmationDownloaded(true));
      } else {
        yield put(setLoaderAction(true));
        const fileUrl = apiResponse?.data?.pdfUrl;
        let fileUrlData = fileUrl.split("?")[0];
        fileUrlData = fileUrlData.split("/");
        new JsFileDownloader({
          url: fileUrl,
          filename: `${
            type === "previous"
              ? "Quote_previous"
              : fileUrlData[fileUrlData?.length - 1]
          }`,
        })
          .then(function () {
            apiResponse && handleSuccess(apiResponse);
            store.dispatch(setLeadConfirmationDownloaded(true));
            store.dispatch(setLoaderAction(false));
            // Called when download ended
          })
          .catch(function (error) {
            // Called when an error occurred
          });
      }
      // apiResponse && handleSuccess(apiResponse);
      // yield put(setLeadEstimateAction(apiResponse?.data))
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddNewLeadAction(false));
    //   yield put(setAdminErrorAction(true));
  }
  yield put(setLoaderMessage(""));
  yield put(setLoaderAction(false));
}

function* getConfirmationNotificationSaga(): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `client/confirmation-notifications`,
    );

    if (apiResponse?.success === true) {
      yield put(
        setConfirmationNotificationAction(apiResponse?.data?.confirmations),
      );
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* cancelInvoiceDepositSaga(action: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    console.log("payload", action);
    const { invoiceId } = action?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "post",
      `account/invoices/${invoiceId}/cancel-deposit`,
    );

    if (apiResponse?.success) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setResponseCancelInvoiceDeposit(true));
    }
  } catch (error: any) {
    // error?.response && handleError(error?.response?.data)
    yield put(setResponseCancelInvoiceDeposit(false));
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* transferInvoiceDepositSaga(action: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { invoiceId } = action?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      action?.payload,
      "post",
      `account/invoices/${invoiceId}/transfer-deposit`,
    );

    if (apiResponse?.success) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setResponseCancelInvoiceDeposit(true));
      // apiResponse && handleSuccess(apiResponse);
    }
  } catch (error: any) {
    // error?.response && handleError(error?.response?.data)
    yield put(setResponseCancelInvoiceDeposit(false));
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* unassignWorkerServiceSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const {confirmationId,serviceId,generateId} = action.payload;
    const apiResponse = yield call<any>(
      callAPI,
      action.payload,
      "delete",
      `leads/confirmations/${confirmationId}/services/${serviceId}/unassign-workers`,
    );

    if (apiResponse?.success === true) {
      yield put(unassignServiceResponse(true));
      apiResponse && handleSuccess(apiResponse);
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(unassignServiceResponse(false));
  }
  yield put(setLoaderAction(false));
}

export function* watchConfirmation() {
  yield takeLatest<any>(
    getConfirmationToolTipAction,
    getConfirmationToolTipSaga,
  );
  yield takeLatest<any>(
    updateConfirmationToolTipAction,
    updateConfirmationToolTipSaga,
  );
  yield takeLatest<any>(getConfirmationAction, getConfirmationSaga);
  yield takeLatest<any>(updateConfirmationAction, updateConfirmationSaga);
  yield takeLatest<any>(
    getLeadConfirmationLinkAction,
    getLeadConfirmationLinkSaga,
  );
  yield takeLatest<any>(
    getConfirmationNotificationAction,
    getConfirmationNotificationSaga,
  );
  yield takeLatest<any>(cancelInvoiceDepositAction, cancelInvoiceDepositSaga);
  yield takeLatest<any>(
    transferInvoiceDepositAction,
    transferInvoiceDepositSaga,
  );
  yield takeLatest<any>(unassignWorkerServiceAction, unassignWorkerServiceSaga);
}
